module.exports = __webpack_public_path__ + "static/27-a8eb4270044d3068f9d69b88df3ef2f6.jpg";